export const FORM_FIELDS = {
  Intent: 'intent',
  Language: 'langauge',
  RedirectTo: 'redirectTo',
  FromDate: 'fromDate',
  ToDate: 'toDate',
  CcId: 'ccId',
  Page: 'page',
  PageSize: 'pagesize',
  active: 'active',
  Create: 'create',
  Select: 'select',
  SortBy: 'sortBy',
  GroupBy: 'groupBy',
  Delete: 'delete',
  Edit: 'edit',
  Import: 'import',
  Reorder: 'reorder'
};
